<template>
	<v-sheet id="project-summary"
		rounded
		class="mb-4">
		<v-card color="#125B92" elevation="0" class="rounded">
			<v-card-text class="white">
				<v-row>
					<v-col cols="6">
						<v-row>
							<v-col>
								<strong class="section-title font-size-2">Relationship Name:</strong><br>
								{{ property.asset_relationship }}
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<strong class="section-title font-size-2">Site Address:</strong><br>
								<span v-html="property.full_address_stacked"></span>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6" align-self="center">
						<v-row>
							<v-col>
								<strong class="mr-2 text section-title font-size-2">Pool/Asset #: </strong>
								{{ property.pool_asset_number ?? 'Not provided' }}
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<strong class="mr-2 section-title font-size-2">UPB: </strong>
								{{ property.upb ?? 'Not provided' }}
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<strong class="mr-2 section-title font-size-2">Property Type: </strong>
								{{ property.type ?? 'Not provided' }}
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-sheet>
</template>
<script>

export default {
	props: {
		property: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
